import React from "react";
import { Navigate, useNavigate } from "react-router-dom";
import logo from "../../assets/images/mmt/logo.png";
import resetBg from "../../assets/images/mmt/bg-reset-password.png";
import { ENV } from "../../configs/environment";
import { buildSessionPath, getStoredSession } from "../mmtUserList/mmtFlow";
import { USER_LIST, LOGIN } from "../../routes/routerPath";
import { pageLocale } from "../../utlis/locale";
import "./mmtlogin.scss";
import "./adminchoice.scss";

export default function AdminChoice() {
  const navigate = useNavigate();
  const session = getStoredSession();
  const t = pageLocale("adminChoice");

  if (!session) return <Navigate to={LOGIN} replace />;

  const goToDashboard = () => {
    const query = new URLSearchParams({
      locale: session.locale || "en",
      origin: "us",
      access_token: session.accessToken,
    });
    window.location.href = `${ENV.DASHBOARD_URL}/home?${query.toString()}`;
  };

  const goToWebApp = () => {
    navigate(buildSessionPath(USER_LIST, session), { replace: true });
  };

  return (
    <main className="mmt-login-page admin-choice-page">
      <section className="mmt-login-scroll">
        <div className="mmt-login-shell admin-choice-shell">
          <div className="mmt-login-art">
            <img src={logo} alt="Senior Life" className="mmt-login-logo" />
          </div>

          <div className="admin-choice-card">
            <p>{t.dashboard_description}</p>
            <button
              type="button"
              className="mmt-primary-button admin-choice-button"
              onClick={goToDashboard}
            >
              {t.dashboard_button}
            </button>
          </div>

          <div className="admin-choice-card">
            <p>{t.webapp_description}</p>
            <button
              type="button"
              className="mmt-primary-button admin-choice-button"
              onClick={goToWebApp}
            >
              {t.webapp_button}
            </button>
          </div>
        </div>
      </section>
      <img src={resetBg} alt="" className="mmt-login-bg" />
    </main>
  );
}
